import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-meter-header-icon',
  templateUrl: './meter-header-icon.component.html',
  styleUrls: ['./meter-header-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MeterHeaderIconComponent {
  @Input() srcSvg?: string;
  @Input() tooltipText?: string;
  @Input() badgeText: string | null = null;
  showTooltip: boolean;

  constructor() {
    this.showTooltip = false;
  }
}
